// extracted by mini-css-extract-plugin
export default {"styledAppBar":"footer_styledAppBar__qttYo","styledRoot":"footer_styledRoot__bECm8"};